<template>
  <div style="width:95%;margin:0 auto">
    <div class="body">
      <h3 class="header">{{title}}</h3>
      <div class="title">已经有:{{count}}人回答了问题</div>
      <div v-for="(item,index) in list" :key="index">
        <h5>{{item.id}}--{{item.item}}</h5>
        <div v-if="item.list">
          <div
            v-for="(people,index) in item.list"
            :key="index"
            style="display:flex; justify-content: space-around;background-color:#ffffff;height:40px;line-height:40px;border-bottom:1px solid rgba(214, 207, 207, 0.733);"
          >
            <!-- <van-cell :title="people.name" :value="people.branch" :label="people.dep" /> -->
            <div>
              <!-- <span style="color:gray">姓名</span> -->
              {{people.name}}
            </div>
            <div>
              <!-- <span style="color:gray">分行</span> -->
              {{people.branch}}
            </div>
            <div>
              <!-- <span style="color:gray">部门</span> -->
              {{people.dep}}
            </div>
          </div>
        </div>
        <div
          v-else
          style="background-color:#fff;height:40px;line-height:40px;border-bottom:1px solid rgba(214, 207, 207, 0.733);color:gray;text-align:center;"
        >未报名</div>
      </div>
    </div>
  </div>
</template>

<script>
import { wxzhuzi, wenjuan } from "../api/wenjuan";

export default {
  data() {
    return {
      radio: "2",
      list: [],
      count: "",
      title: "",
      id: this.$route.query.id
    };
  },
  methods: {},
  created() {
    if (this.id) {
      this.$http.get("/oa/wxzhuzi/answer?id=" + this.id).then(res => {
        this.title = res.data.data.title;
        this.count = res.data.data.count;
        this.list = res.data.data.list;
      });
    } else {
      this.$http.get("/oa/wxzhuzi/answer?id=" + 1).then(res => {
        this.title = res.data.data.title;
        this.count = res.data.data.count;
        this.list = res.data.data.list;
      });
    }
  }
};
</script>

<style scoped>
.title {
  width: 90%;
  margin: 10px;
  font-size: 12px;
  color: gray;
}
.header {
  width: 100%;
  text-align: center;
  margin: 10px 0 0 0;
}
.body {
  background: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/views/admin.vue